import z from 'zod'

export const EventDTOScheme = z.object({
	id: z.string().nullable().optional(),
	name: z.string().nullable().optional(),
	url: z.string().nullable().optional(),
	detail: z.string().nullable().optional(),
	picture: z.string().nullable().optional(),
	date: z.string().nullable().optional()
})

export type EventDTO = z.output<typeof EventDTOScheme>
